import { styled } from '../theme';

const ModalBody = styled.div({
    position: 'relative',
    padding: 24,
    fontSize: '1.6rem',
});

export default ModalBody;
